import { createSlice } from '@reduxjs/toolkit';
import { set } from 'lodash';
const initialState = {
    edsCFEPagesVisited: [],
    edsSDKPagesVisited: [],
    edsLocationId: null,
};
const slice = createSlice({
    name: 'eds',
    initialState,
    reducers: {
        pushEdsCFEPagesVisited: (state, action) => {
            set(state, 'edsCFEPagesVisited', [
                ...state.edsCFEPagesVisited,
                action.payload,
            ]);
        },
        setEdsCFEPagesVisited: (state, action) => {
            set(state, 'edsCFEPagesVisited', action.payload);
        },
        pushEdsSDKPagesVisited: (state, action) => {
            set(state, 'edsSDKPagesVisited', [
                ...state.edsSDKPagesVisited,
                action.payload,
            ]);
        },
        setEdsSDKPagesVisited: (state, action) => {
            set(state, 'edsSDKPagesVisited', action.payload);
        },
        setEdsLocationId: (state, action) => {
            set(state, 'edsLocationId', action.payload);
        },
    },
});
export const { pushEdsCFEPagesVisited, setEdsCFEPagesVisited, pushEdsSDKPagesVisited, setEdsSDKPagesVisited, setEdsLocationId, } = slice.actions;
export default slice.reducer;
